import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useApp } from "@/components/AppShell";
import { typeMeta, prioMeta, STATUSES } from "@/lib/meta";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function MyWork() {
  const { user } = useAuth();
  const { openIssue } = useApp();
  const [issues, setIssues] = useState([]);
  useEffect(() => { api.get("/issues", { params: { assignee_id: user.id } }).then(r => setIssues(r.data)); }, [user.id]);

  const grouped = STATUSES.map(s => ({ s, list: issues.filter(i => i.status === s.id) }));
  return (
    <div className="px-6 py-6 max-w-[1400px]">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Focus</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">My work</h1>
      </div>
      {issues.length === 0 && <div className="text-sm text-muted-foreground border border-dashed border-border rounded-md p-10 text-center">You have no assigned issues.</div>}
      <div className="space-y-4">
        {grouped.map(({ s, list }) => list.length > 0 && (
          <Card key={s.id} className="p-4">
            <div className="flex items-center gap-2 mb-3"><h3 className="font-display font-semibold">{s.label}</h3><span className="text-xs text-muted-foreground font-mono">{list.length}</span></div>
            <div className="divide-y divide-border -mx-2">
              {list.map(i => {
                const T = typeMeta(i.issue_type); const P = prioMeta(i.priority);
                return (
                  <button key={i.id} onClick={()=>openIssue(i.id)} data-testid={`mywork-${i.key}`} className="w-full px-2 py-2 flex items-center gap-3 hover:bg-accent rounded-md text-left transition-colors">
                    <T.icon className={cn("w-4 h-4", T.cls)} />
                    <span className="font-mono text-xs text-muted-foreground w-16">{i.key}</span>
                    <span className="flex-1 truncate text-sm">{i.summary}</span>
                    <P.icon className={cn("w-4 h-4", P.cls)} />
                  </button>
                );
              })}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
